<template>
  <div class="service-package-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">租房系统</el-breadcrumb-item>
      <el-breadcrumb-item>随心住服务包</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 标签页 -->
    <div class="tab-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="生效中" name="active"></el-tab-pane>
        <el-tab-pane label="已到期" name="expired"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-container">
      <div class="filter-item">
        <span class="filter-label">服务卡号</span>
        <el-input v-model="filterForm.cardNumber" placeholder="请输入内容" class="filter-input"></el-input>
      </div>
      <div class="filter-item">
        <span class="filter-label">套餐类型</span>
        <el-select v-model="filterForm.packageType" placeholder="全部" class="filter-select">
          <el-option label="全部" value=""></el-option>
          <el-option label="1年（360）￥" value="1"></el-option>
          <el-option label="一个月（100）￥" value="2"></el-option>
          <el-option label="三个月（199）￥" value="3"></el-option>
          <el-option label="六个月（299）￥" value="4"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <el-button type="primary" @click="handleSearch" class="filter-button">查询</el-button>
        <el-button @click="resetFilter" class="filter-button">重置</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="cardNumber" label="服务卡号" min-width="120"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span class="status-text" :class="{'status-active': scope.row.status === '生效中'}">{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="packageType" label="套餐" width="100"></el-table-column>
        <el-table-column prop="usage" label="使用次数" width="100"></el-table-column>
        <el-table-column prop="purchaseDate" label="购买日期" width="120"></el-table-column>
        <el-table-column prop="expiryDate" label="到期日期" width="120"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewPropertyInfo(scope.row)">房源信息</el-button>
            <el-button type="text" size="small" @click="viewMaintenanceRecord(scope.row)">维修记录</el-button>
            <el-button type="text" size="small" class="blue-text" @click="registerMaintenance(scope.row)">登记维修</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <span class="total-text">共 {{ total }} 项数据</span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 维修记录对话框 -->
    <el-dialog
      title="维修记录"
      :visible.sync="maintenanceListVisible"
      width="70%">
      <el-table :data="maintenanceList" style="width: 100%" v-loading="maintenanceLoading">
        <el-table-column prop="content" label="维修内容" min-width="150"></el-table-column>
        <el-table-column prop="repairTime" label="维修日期" width="160"></el-table-column>
        <el-table-column prop="provider" label="服务商" width="120"></el-table-column>
        <el-table-column prop="cost" label="成本" width="80">
          <template slot-scope="scope">
            <span class="cost-text">¥{{ scope.row.cost }}</span>
          </template>
        </el-table-column>
        <el-table-column label="维修状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" class="status-tag">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteMaintenanceRecord(scope.row)">撤销</el-button>
            <el-button type="text" size="small" @click="unfinishMaintenanceRecord(scope.row)">未完成</el-button>
            <el-button type="text" size="small" class="success-text" @click="completeMaintenanceRecord(scope.row)">已完成</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-text">暂无数据</div>
        </template>
      </el-table>
      <div class="pagination-container">
        <span class="total-text">共 {{ maintenanceTotal }} 项数据</span>
        <el-pagination
          @size-change="handleMaintenanceSizeChange"
          @current-change="handleMaintenanceCurrentChange"
          :current-page="maintenanceCurrentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="maintenancePageSize"
          layout="sizes, prev, pager, next, jumper"
          :total="maintenanceTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 导入房源上传组件 -->
    <house-upload
      :visible.sync="houseUploadVisible"
      :is-edit="false"
      :is-view-only="true"
      :edit-data="houseUploadData"
      @submit-success="handleHouseSubmitSuccess"
    ></house-upload>

    <!-- 维修登记对话框 -->
    <el-dialog
      title="维修登记"
      :visible.sync="maintenanceRegisterVisible"
      width="60%"
      class="repair-dialog">
      <div class="repair-form">
        <div class="form-section">
          <h3>房源信息</h3>
          <div class="info-row">
            <div class="info-item">
              <span class="label">地址</span>
              <span class="value">{{ currentHouseInfo.address || '' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">出租类型</span>
              <span class="value">{{ currentHouseInfo.rentType || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">户型</span>
              <span class="value">{{ currentHouseInfo.houseType || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">电梯</span>
              <span class="value">{{ currentHouseInfo.elevator || '' }}</span>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3>租客信息</h3>
          <div class="info-row">
            <div class="info-item">
              <span class="label">租房人姓名</span>
              <span class="value">{{ currentHouseInfo.tenantName || '' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">租房人身份证号</span>
              <span class="value">{{ currentHouseInfo.tenantIdCard || '' }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-item">
              <span class="label">手机号</span>
              <span class="value">{{ currentHouseInfo.tenantPhone || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">入住时间</span>
              <span class="value">{{ currentHouseInfo.checkInDate || '' }}</span>
            </div>
          </div>
        </div>

        <el-form :model="repairForm" :rules="repairRules" ref="repairForm" label-width="120px" class="repair-input-form">
          <el-form-item label="维修内容" prop="content" class="required-item">
            <el-input type="textarea" v-model="repairForm.content" rows="3" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="维修成本" prop="cost" class="required-item">
            <el-input v-model="repairForm.cost" placeholder="请输入价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="维修日期" prop="repairTime" class="required-item">
            <el-date-picker
              v-model="repairForm.repairTime"
              type="datetime"
              placeholder="请选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="'08:00:00'">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否自费" prop="isSelfPaid" class="required-item">
            <el-radio v-model="repairForm.isSelfPaid" label="是">是</el-radio>
            <el-radio v-model="repairForm.isSelfPaid" label="否">否</el-radio>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone" class="required-item">
            <el-input v-model="repairForm.contactPhone" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item label="维修提供商" prop="provider" class="required-item">
            <el-input v-model="repairForm.provider" placeholder="请输入维修提供商"></el-input>
          </el-form-item>
          <el-form-item label="租客性别" prop="gender" class="required-item">
            <el-radio v-model="repairForm.gender" label="男">男</el-radio>
            <el-radio v-model="repairForm.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="repairForm.remark" rows="2" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="maintenanceRegisterVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRepair" :loading="submitLoading">提交登记</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getReq, postRed } from '@/api/axiosFun'
import HouseUpload from './houseUpload.vue'

export default {
  name: 'ServicePackage',
  components: {
    HouseUpload
  },
  data() {
    return {
      activeTab: 'all',
      filterForm: {
        cardNumber: '',
        packageType: ''
      },
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,

      // 房源上传组件相关
      houseUploadVisible: false,
      houseUploadData: null,

      // 维修记录相关
      maintenanceListVisible: false,
      currentHouseId: '',
      maintenanceList: [],
      maintenanceLoading: false,
      maintenanceTotal: 0,
      maintenanceCurrentPage: 1,
      maintenancePageSize: 20,

      // 维修登记相关
      maintenanceRegisterVisible: false,
      currentHouseInfo: {},
      repairForm: {
        content: '',
        cost: '',
        repairTime: '',
        isSelfPaid: '否',
        contactPhone: '',
        gender: '男',
        status: '待处理',
        remark: '',
        provider: '',
        worryFreeId: ''
      },
      repairRules: {
        content: [{ required: true, message: '请详细描述维修内容', trigger: 'blur' }],
        cost: [{ required: true, message: '请输入维修费用', trigger: 'blur' }],
        repairTime: [{ required: true, message: '请选择维修时间', trigger: 'blur' }],
        isSelfPaid: [{ required: true, message: '请选择是否自费', trigger: 'change' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择租客性别', trigger: 'change' }],
        provider: [{ required: true, message: '请输入维修提供商', trigger: 'blur' }]
      },
      submitLoading: false,

      // 套餐类型映射
      packageTypeMap: {
        '1': '1年（360）￥',
        '2': '一个月（100）￥',
        '3': '三个月（199）￥',
        '4': '六个月（299）￥'
      }
    }
  },
  created() {
    this.getList()
    // 初始化repairForm中的时间为北京时间
    this.repairForm.repairTime = this.getCurrentBeijingTime()
  },
  methods: {
    getList() {
      // 获取token
      const token = localStorage.getItem('token') || '';

      // 构建请求参数
      const params = {
        page: this.pageSize,
        limit: this.currentPage,
        cardNumber: this.filterForm.cardNumber || '',
        type: this.filterForm.packageType || '',
        status: this.getStatusFilter(),
        token: token
      };

      // 使用通用请求方法获取服务包数据
      getReq('get', '/rentHouse/selectAllWorry', params)
        .then(response => {
          if (response.status === 200) {
            const responseData = response.data || {};

            // 获取列表数据和总数
            this.tableData = (responseData.list || []).map(item => {
              return {
                id: item.id,
                cardNumber: item.cardNumber,
                status: item.status,
                packageType: this.getPackageType(item.type),
                usage: item.useNumber || 0,
                purchaseDate: item.startTime ? this.formatDate(item.startTime) : '',
                expiryDate: item.endTime ? this.formatDate(item.endTime) : '',
                remark: item.remark || '暂无',
                houseId: item.houseOrderId
              };
            });

            this.total = responseData.totalRow || 0;
          } else {
            this.$message.error((response.data && response.data.message) || '获取服务包列表失败');
            this.tableData = [];
            this.total = 0;
          }
        }).catch(error => {
          console.error('获取服务包列表错误:', error);
          this.$message.error('获取服务包列表失败，请重试');
          this.tableData = [];
          this.total = 0;
        });
    },
    // 获取套餐类型
    getPackageType(type) {
      return this.packageTypeMap[type] || '未知套餐';
    },
    // 根据当前选中的标签页获取状态过滤条件
    getStatusFilter() {
      if (this.activeTab === 'active') return '生效中';  // 生效中
      if (this.activeTab === 'expired') return '已到期'; // 已到期
      return '';  // 全部
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    handleTabClick() {
      this.currentPage = 1
      this.getList()
    },
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    resetFilter() {
      this.filterForm = {
        cardNumber: '',
        packageType: ''
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    viewPropertyInfo(row) {
      // 获取房源信息
      getReq('get', '/rentHouse/selectRentHouseByWorryId', { id: row.id })
        .then(response => {
          if (response.status === 200 && response.data) {
            // 获取到房源信息数据
            const houseData = response.data;
            // 打开房源编辑弹窗
            this.houseUploadData = houseData;
            this.houseUploadVisible = true;
          } else {
            this.$message.error('获取房源信息失败');
          }
        })
        .catch(error => {
          console.error('获取房源信息错误:', error);
          this.$message.error('获取房源信息失败，请重试');
        });
    },
    // 处理房源编辑成功后的回调
    handleHouseSubmitSuccess(data) {
      this.$message.success('房源信息更新成功');
      this.getList(); // 刷新列表
    },
    viewMaintenanceRecord(row) {
      // 打开维修记录对话框
      this.maintenanceListVisible = true;
      this.maintenanceLoading = true;
      this.maintenanceList = [];
      this.currentHouseId = row.id;

      this.loadMaintenanceRecords();
    },

    // 加载维修记录
    loadMaintenanceRecords() {
      // 调用接口获取维修记录
      getReq('get', '/rentHouse/repairList', {
        id: this.currentHouseId,
        page: this.maintenanceCurrentPage,
        limit: this.maintenancePageSize
      })
        .then(response => {
          this.maintenanceLoading = false;
          if (response.status === 200) {
            // 处理维修记录数据 - 接口直接返回数组
            if (Array.isArray(response.data)) {
              this.maintenanceList = response.data;
              this.maintenanceTotal = response.data.length;
            } else if (response.data && response.data.list) {
              // 兼容处理，如果返回的是对象格式
              this.maintenanceList = response.data.list || [];
              this.maintenanceTotal = response.data.totalRow || 0;
            } else {
              this.maintenanceList = [];
              this.maintenanceTotal = 0;
            }

            // 如果没有记录
            if (this.maintenanceList.length === 0) {
              this.$message.info('暂无维修记录');
            }
          } else {
            this.$message.error('获取维修记录失败');
            this.maintenanceList = [];
            this.maintenanceTotal = 0;
          }
        })
        .catch(error => {
          this.maintenanceLoading = false;
          console.error('获取维修记录错误:', error);
          this.$message.error('获取维修记录失败，请重试');
          this.maintenanceList = [];
          this.maintenanceTotal = 0;
        });
    },
    registerMaintenance(row) {
      // 打开维修登记对话框
      this.currentHouseInfo = {
        id: row.id  // 保存当前记录ID
      };

      // 获取房源信息填充到表单中
      getReq('get', '/rentHouse/selectRentHouseByWorryId', { id: row.id })
        .then(response => {
          if (response.status === 200 && response.data) {
            const houseData = response.data;
            // 设置房源信息
            this.currentHouseInfo = {
              ...this.currentHouseInfo,
              address: houseData.address || '',
              rentType: houseData.type || '',
              houseType: houseData.housePattern || '',
              elevator: houseData.isLift ? '是' : '否',
              // 租客信息先设置默认值
              tenantName: '',
              tenantIdCard: '',
              tenantPhone: houseData.phoneNumber || '',
              checkInDate: houseData.checkTime || ''
            };

            // 获取租客信息
            getReq('get', '/rentHouse/selectHouseOrderByWorry', { worryId: row.id })
              .then(tenantRes => {
                if (tenantRes.status === 200 && tenantRes.data) {
                  const tenantData = tenantRes.data;
                  // 更新租客信息
                  this.currentHouseInfo = {
                    ...this.currentHouseInfo,
                    tenantName: tenantData.userName || '',
                    tenantIdCard: tenantData.userIdCard || '',
                    tenantPhone: tenantData.userPhone || this.currentHouseInfo.tenantPhone,
                    checkInDate: tenantData.startTime || this.currentHouseInfo.checkInDate
                  };

                  // 自动填充联系电话
                  this.repairForm.contactPhone = tenantData.userPhone || '';
                }
                // 无论是否获取到租客信息，都打开对话框
                this.maintenanceRegisterVisible = true;
              })
              .catch(error => {
                console.error('获取租客信息错误:', error);
                // 获取租客信息失败，也打开对话框，使用默认值
                this.maintenanceRegisterVisible = true;
              });
          } else {
            this.$message.error('获取房源信息失败');
          }
        })
        .catch(error => {
          console.error('获取房源信息错误:', error);
          this.$message.error('获取房源信息失败，请重试');
        });

      // 重置表单
      this.repairForm = {
        content: '',
        cost: '',
        repairTime: this.getCurrentBeijingTime(),
        isSelfPaid: '否',
        contactPhone: '',
        gender: '男',
        status: '待处理',
        remark: '',
        provider: '',
        worryFreeId: row.id  // 设置无忧卡ID
      };
    },
    // 提交维修登记
    submitRepair() {
      this.$refs.repairForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          // 确保时间是北京时间
          let repairTime = this.repairForm.repairTime;
          if (!repairTime) {
            repairTime = this.getCurrentBeijingTime();
          }

          // 构建提交参数
          const params = {
            content: this.repairForm.content,
            cost: this.repairForm.cost,
            provider: this.repairForm.provider,
            repairTime: repairTime,
            status: this.repairForm.status,
            remark: this.repairForm.remark || '',
            worryFreeId: this.repairForm.worryFreeId
          };

          // 调用API提交维修登记
          postRed('post', '/rentHouse/recordRepair', params)
            .then(response => {
              this.submitLoading = false;
              if (response.status === 200) {
                this.$message.success('维修登记提交成功');
                this.maintenanceRegisterVisible = false;
                this.getList(); // 刷新列表
              } else {
                this.$message.error((response.data && response.data.message) || '维修登记提交失败');
              }
            })
            .catch(error => {
              this.submitLoading = false;
              console.error('维修登记提交错误:', error);
              this.$message.error('维修登记提交失败，请重试');
            });
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    deleteMaintenanceRecord(row) {
      this.$confirm('确认撤销此维修记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除接口
        getReq('get', '/rentHouse/changeRepairStatus', { repairId: row.id, status: '已删除' })
          .then(response => {
            if (response.status === 200) {
              this.$message.success('撤销成功');
              // 重新加载数据
              this.loadMaintenanceRecords();
            } else {
              this.$message.error('撤销失败');
            }
          })
          .catch(error => {
            console.error('撤销维修记录错误:', error);
            this.$message.error('撤销失败，请重试');
          });
      }).catch(() => {
        // 用户取消删除
      });
    },
    unfinishMaintenanceRecord(row) {
      // 调用接口将维修记录状态设为未完成
      getReq('get', '/rentHouse/changeRepairStatus', { repairId: row.id, status: '未完成' })
        .then(response => {
          if (response.status === 200) {
            this.$message.success('维修记录状态已更新为未完成');
            this.loadMaintenanceRecords();
          } else {
            this.$message.error('状态更新失败');
          }
        })
        .catch(error => {
          console.error('更新维修记录状态错误:', error);
          this.$message.error('状态更新失败，请重试');
        });
    },
    completeMaintenanceRecord(row) {
      // 调用接口更新维修记录状态
      getReq('get', '/rentHouse/changeRepairStatus', { repairId: row.id, status: '已完成' })
        .then(response => {
          if (response.status === 200) {
            this.$message.success('维修记录状态已更新为已完成');
            this.loadMaintenanceRecords();
          } else {
            this.$message.error('维修记录状态更新失败');
          }
        })
        .catch(error => {
          console.error('更新维修记录状态错误:', error);
          this.$message.error('维修记录状态更新失败，请重试');
        });
    },
    getStatusTagType(status) {
      if (status === '已完成') return 'success';
      if (status === '待处理') return 'warning';
      return '';
    },
    handleMaintenanceSizeChange(val) {
      this.maintenancePageSize = val;
      this.loadMaintenanceRecords();
    },
    handleMaintenanceCurrentChange(val) {
      this.maintenanceCurrentPage = val;
      this.loadMaintenanceRecords();
    },
    // 获取当前北京时间
    getCurrentBeijingTime() {
      // 获取当前时间
      const date = new Date();

      // 获取本地时间与UTC时间的差值（分钟）
      const localOffset = date.getTimezoneOffset();

      // 计算北京时间偏移量（UTC+8，单位为分钟）
      const beijingOffset = -480; // UTC+8 = -480分钟

      // 计算当前时间与北京时间的差值（毫秒）
      const offsetMs = (beijingOffset - localOffset) * 60 * 1000;

      // 创建北京时间
      const beijingTime = new Date(date.getTime() + offsetMs);

      // 格式化日期时间
      const year = beijingTime.getFullYear();
      const month = String(beijingTime.getMonth() + 1).padStart(2, '0');
      const day = String(beijingTime.getDate()).padStart(2, '0');
      const hours = String(beijingTime.getHours()).padStart(2, '0');
      const minutes = String(beijingTime.getMinutes()).padStart(2, '0');
      const seconds = String(beijingTime.getSeconds()).padStart(2, '0');

      // 返回格式化的北京时间
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
}
</script>

<style scoped>
.service-package-container {
  padding: 20px;
}

.tab-container {
  margin-bottom: 20px;
}

.filter-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.filter-label {
  margin-right: 10px;
  color: #606266;
}

.filter-input {
  width: 200px;
}

.filter-select {
  width: 160px;
}

.filter-button {
  margin-left: 10px;
}

.table-container {
  margin-bottom: 20px;
}

.status-text {
  padding: 2px 0;
  display: inline-block;
}

.status-active {
  color: #67C23A;
}

.blue-text {
  color: #409EFF;
}

.success-text {
  color: #67C23A;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.total-text {
  color: #606266;
  font-size: 14px;
}

/* 房源信息样式 */
.house-info-container {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 20px;
}

.house-info-item {
  width: 50%;
  margin-bottom: 15px;
  display: flex;
}

.info-label {
  font-weight: bold;
  width: 100px;
  color: #606266;
}

.info-value {
  flex: 1;
}

.no-data {
  text-align: center;
  padding: 30px 0;
  color: #909399;
}

/* 维修表单样式 */
.repair-dialog .el-dialog__body {
  padding: 10px 20px;
}

.repair-form {
  padding: 0 10px;
}

.form-section {
  margin-bottom: 20px;
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 10px;
}

.form-section h3 {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.info-item {
  min-width: 33%;
  margin-bottom: 10px;
  display: flex;
}

.label {
  width: 100px;
  color: #606266;
  text-align: right;
  padding-right: 12px;
}

.value {
  flex: 1;
  color: #303133;
}

.required-item .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

.repair-input-form {
  margin-top: 20px;
}

.cost-text {
  color: #F56C6C;
  font-weight: bold;
}

.status-tag {
  padding: 2px 8px;
}

/* 维修记录对话框样式 */
.el-dialog__body {
  padding: 15px 20px;
}

.el-table .cell {
  white-space: nowrap;
}

.el-table .status-tag {
  margin: 0;
}

.empty-text {
  text-align: center;
  padding: 20px 0;
  color: #909399;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/rentalSystem/servicePackage.vue